import { Checkbox, TextField } from "@material-ui/core";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { fieldToTextField } from "formik-material-ui";
import React, { useState } from "react";

export default (props) => {
  const [state, setState] = useState([]);

  const {
    form: { setTouched, setFieldValue },
    onChange,
    onClose,
  } = props;

  const { error, helperText, ...field } = fieldToTextField(props);
  const { name } = field;

  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

  const handleChange = (event, value, reason) => {
    setState(value);
    setFieldValue(name, value);
    onChange?.call(null, event, value, reason);
  };

  const handleClose = () => {
    setFieldValue(name, state);
    onClose?.call(null, state);
  };

  return (
    <Autocomplete
      {...props.field}
      getOptionLabel={(option) => option.nome}
      multiple
      autoComplete
      openText="Abrir"
      closeText="Fechar"
      clearText="Limpar"
      noOptionsText="Sem opções"
      disableCloseOnSelect={true}
      disabled={props.options.length == 0}
      onBlur={() => setTouched({ [name]: true })}
      onClose={handleClose}
      onChange={handleChange}
      limitTags={3}
      id={props.id}
      groupBy={(option) => option.label}
      options={props.options}
      renderOption={(option, { selected }) => (
        <React.Fragment>
          <Checkbox
            color="primary"
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 13, marginLeft: 0 }}
            checked={selected}
          />
          {option.nome}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...props.field}
          {...params}
          onChange={() => null}
          fullWidth
          value={state}
          variant="standard"
          label={props.label}
        />
      )}
    />
  );
};
